import { useEffect } from 'react'
import styled from 'styled-components'
import { Grid, Wrapper, H } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import isEmpty from 'lodash/isEmpty'

import { getFullNameWithPreferredName } from 'utils/helpers'

import { Uppercase } from 'components/styled/uppercase'
import NavigationTabs from 'components/navigation-tabs'
import TelephoneAndEmailContacts from 'components/phone-email-contacts'
import PrivateRoute from 'components/private-route'
import NotFound from 'routes/not-found'
import { BrandIndicator } from 'components/brand-indicator'
import { MAP_BRAND_ID_TO_NAME } from 'config/brands'

import {
  ContactContextProvider,
  useContactContext,
} from 'routes/contact/context'

import Summary from './components/summary'

type OnlineWillProps = {
  match: { path: string; params: { contactId: string } }
}

const StyledTitleWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;
  gap: ${GTR.XS};
`

const OnlineWill = ({ match }: OnlineWillProps) => {
  const { path, params } = match
  const contactId = params.contactId

  const { contact, fetchContact, isFetchingContact } = useContactContext()
  const noContact = isEmpty(contact)

  useEffect(() => {
    fetchContact()
  }, [contactId, fetchContact])

  if (isFetchingContact && noContact) return <Uppercase>Loading...</Uppercase>

  if (noContact) return <NotFound />

  const { attributes } = contact
  const NAV_LINKS = [{ label: 'Summary', url: `/online-will/${contactId}` }]

  return (
    <>
      <Grid separator padding={[GTR.L, 0, 0]}>
        <Grid.Item spanFromM={8}>
          <Uppercase>Customer &bull; Will storage</Uppercase>
          <StyledTitleWrapper margin={[0, 0, 'XS']}>
            <H size="XL" decorative margin={0}>
              {getFullNameWithPreferredName(attributes) || 'Unknown'}
            </H>
          </StyledTitleWrapper>
          <TelephoneAndEmailContacts
            contact={contact}
            contactId={Number(contactId)}
            withLink
          />
          {attributes.brandId && (
            <Wrapper margin={['S', 0, 0]}>
              <BrandIndicator
                brand={MAP_BRAND_ID_TO_NAME[attributes.brandId]}
              />
            </Wrapper>
          )}
        </Grid.Item>
      </Grid>
      <Wrapper separator>
        <NavigationTabs links={NAV_LINKS} />
      </Wrapper>
      <Wrapper separator>
        <PrivateRoute
          path={path}
          exact
          component={Summary}
          contactId={Number(contactId)}
        />
      </Wrapper>
    </>
  )
}

const OnlineWillWithContext = (props: OnlineWillProps) => (
  <ContactContextProvider contactId={props.match.params.contactId}>
    <OnlineWill {...props} />
  </ContactContextProvider>
)

export default OnlineWillWithContext
